import React, { useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'
import TextField from '../BasicFields/TextField'
import TrashCanIcon from '../../ui/icons/TrashCanIcon'
import Tooltip from '../../ui/Tooltip'

const DELETION_LOCKED = 'deletion_locked'
const LOCKED_TRASH_TOOLTIP = 'Suppression impossible : ce choix a été ajouté lors d\'une saisie '
  + 'et il est utilisé dans une réponse. Vous pouvez seulement en modifier l\'intitulé.'

const SelectionOption = ({
  option,
  handleOptionChange,
  handleRemoveOption,
  multi = false
}) => {
  const handleChange = useCallback(({ target: { name, value } }) => {
    handleOptionChange({ ...option, [name]: value })
  }, [handleOptionChange, option])

  const handleDefaultChange = useCallback(() => {
    handleOptionChange({ ...option, default: !option.default })
  }, [handleOptionChange, option])

  const optionIcon = useMemo(() => {
    const icon = multi ? 'fa-square' : 'fa-circle'
    const weight = option.default ? 'far text-success' : 'far'
    const title = option.default ? 'Choix par défaut' : 'Définir comme choix par défaut'

    return (
      <i
        className={`${weight} ${icon} option-circle`}
        title={title}
        onClick={handleDefaultChange}
      />
    )
  }, [multi, option.default, handleDefaultChange])

  return (
    <>
      <div className="nested-fields ml-2 ml-md-4">
        {optionIcon}
        <div className="option-field">
          <TextField name="content" value={option.content} onChange={handleChange} />
        </div>
        <div className="option-trash">
          {option[DELETION_LOCKED] ? (
            <Tooltip content={LOCKED_TRASH_TOOLTIP}>
              <TrashCanIcon className="tw:text-gray-300 tw:cursor-not-allowed" disabled />
            </Tooltip>
          ) : (
            <TrashCanIcon
              className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer"
              onClick={handleRemoveOption}
            />
          )}
        </div>
      </div>
      <div className="clearfix" />
    </>
  )
}

SelectionOption.propTypes = {
  handleOptionChange: PropTypes.func.isRequired,
  handleRemoveOption: PropTypes.func.isRequired,
  option: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    content: PropTypes.string.isRequired,
    default: PropTypes.bool,
    [DELETION_LOCKED]: PropTypes.bool
  }).isRequired
}

export default SelectionOption